<template>
  <div class="loader" ref="loader">
    <div class="loader-container">
      <div class="loader-line">
        <span class="loader-loaded" :style="{transform: 'scaleX(' + ( percentage / 100 ) + ')'}"></span>
      </div>
    </div>
  </div>
</template>

<script>
import { TweenLite, Power2 } from 'gsap'

export default {
  props: {
    percentage: Number,
    required: true,
    default: 0
  },
  mounted () {
    this.$refs.loader.classList.add('init')
  },
  methods: {
    loadComplete: function () {
      TweenLite.to('.loader', 0.3, {
        delay: 0.5,
        opacity: 0,
        ease: Power2.easeOut,
        onComplete: () => {
          this.$destroy()
          this.$el.remove()
          this.$store.state.isPageLoaded = true
          // this gabage needs to be killed
        }
      })
    }
  },
  watch: {
    percentage: function (newVal, oldVal) {
      if (newVal >= 100) this.loadComplete()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/myLoader.vue